import { useState, useEffect } from "react";
import { CountryService } from "../../services/CountryService";
import { Divider } from "primereact/divider";
import { Link } from "react-router-dom";
import { AddPageHeader } from "../Common/Utils";
import NewsletterTable from "../Common/NewsletterTable";

const Newsletter = () => {
  const [data, setNewsletter] = useState([]);
  const countryService = new CountryService();

  useEffect(() => {
    countryService.getNewsletter().then((data) => setNewsletter(data));
  }, []);

  return (
    <div className="reduce-width">
      {AddPageHeader("The Consular Newsletter")}
      <Divider align="center">
        <h1>The Consular Newsletter</h1>
      </Divider>
      <div className="privacy-terms">
        Every week, The Consular Newsletter updates consular officials,
        diplomats, migration lawyers, researchers, and travel industry
        professionals with the latest major news on consular affairs and
        diplomatic networks. Are you a recognized press body? Interested in
        highlighting specific news? Please feel free to{" "}
        <Link
          to="/contact"
          style={{
            color: "black",
            fontWeight: "bold",
          }}
        >
          contact
        </Link>{" "}
        the Center.
      </div>
      <br />
      <div
        className="flex h-full gap-3 justify-content-center"
        style={{ height: "100%" }}
      >
        <div style={{ display: "flex", justifyContent: "center" }}>
          <a
            href="https://newsletter.consularaffairs.org/"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              fontWeight: "bold",
              width: "220px",
              maxWidth: "90%",
              textDecoration: "none",
            }}
          >
            <div className="text-center p-3 border-round-sm bg-primary h-full flex flex-column justify-content-center">
              <div>Subscribe via email</div>
            </div>
          </a>
        </div>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <a
            href="https://www.linkedin.com/newsletters/the-consular-newsletter-7234194857521504257"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              fontWeight: "bold",
              width: "220px",
              maxWidth: "90%",
              textDecoration: "none",
            }}
          >
            <div className="text-center p-3 border-round-sm bg-primary h-full flex flex-column justify-content-center">
              <div>Subscribe via LinkedIn</div>
            </div>
          </a>
        </div>
      </div>
      <NewsletterTable data={data} searchEnabled longDescription />
    </div>
  );
};

export default Newsletter;
